import ApiWebCallEvo, {
    API_URL_USER_PART
} from "./calls/evo-api-call";


import {API_URL_BOOKMARKS_PART} from './abstract-bookmark-data-provider';

/*./api/json/user/1/bookmarks/issue/1*/

export default class IssueBookmarksDataProvider  {

    constructor() {}

    /**
     *
     * @param userId
     * @param issueId
     * @param authToken
     * @param params
     * @param headers
     */
    public async getData(userId: number, issueId = 0, authToken: string, params = {},  headers: { [key: string | number]: string | number} = {}) {

        headers["Auth-token"] = authToken;

        let apiCall = new ApiWebCallEvo(
            API_URL_USER_PART + '/' + userId + API_URL_BOOKMARKS_PART + '/issue/' +issueId,
            params,
            headers
        );

        let res = await apiCall.makeCall();

        return res;
        /*if (res.status === apiCall.STATUS_OK) {
           return res.data;
       } else {
           throw new Error(res.errors[0]);
       }*/
    }
}